import { bankProducts } from "common/constants/constants";

export const scrolToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const formatPermissions = (Permissions) => {
  return Permissions.filter((el, i, arr) => el.isVisible)
    .map((el, i) => {
      return { main: { ...el, all: "", value: false }, id: i + 1, sub: [] };
    })
    .map((el, i) => {
      Permissions.filter((item) => item.parentId === el.main.claimKey && item.isVisible).forEach(
        (element) => {
          el.sub.push({
            ...element,
            id: i + 1,
            all: "",
            value: false,
          });
        }
      );
      return el;
    });
};

export const getUserRoleFromStorage = () => JSON.parse(localStorage.getItem("userRole"));

export const getUserIdFromStorage = () => JSON.parse(localStorage.getItem("userId"));

export const getApplicationKeysFromStorage = () =>
  JSON.parse(localStorage.getItem("applicationKeys"));
export const IsAllProductsAssigned = (products = []) => {
  return (
    products.length === bankProducts.length &&
    bankProducts.every(
      (value) =>
        value.key.toLowerCase() ===
        products.filter((item) => item?.productId?.toLowerCase() === value?.key.toLowerCase())[0]
          ?.productId
    )
  );
};

export const getMatchedProducts = (product) => {
  return bankProducts.filter((o) =>
    product.some((i) => i.productId?.toLowerCase() === o.key.toLowerCase())
  );
};

export const getGeccoLogin = () => {
  const products = JSON.parse(localStorage.getItem("products"))
  return products.some(item => item.productId.toLowerCase() === "4197de32-f676-4144-a688-52580fa10fa6");
}


export const getEsgLogin = () => {
  const products = JSON.parse(localStorage.getItem("products"))
  return products.some(item => item.productId.toLowerCase() === "89f6a985-4b94-49ba-a4ef-629a781bd7d2");
}